import React from 'react';
import styles from './Toggle.module.scss';
import cn from 'classnames';

interface IPropTypes {
  value: boolean;
  onChange?: (value: boolean) => void;
}

export const Toggle: React.FC<IPropTypes> = React.memo(
  ({ value, onChange }) => {
    return (
      <div
        className={cn(styles.Toggle, {
          [styles.Toggle_State_On]: value,
          [styles.Toggle_State_Off]: !value,
        })}
        onClick={() => {
          onChange?.(!value);
        }}
      >
        <div className={styles.Toggle__Thumb} />
      </div>
    );
  }
);
Toggle.displayName = 'Toggle';
